import {WidgetDefinition, WidgetTextStyle} from "./common";
import WidgetType from "../enum/WidgetType";
import ProductSubtitlePosition from "../enum/ProductSubtitlePosition";
import Font from '../enum/Font';
import TextAlignment from "../enum/TextAlignment";
import PriceMode from '../enum/PriceMode';
import AssetContentMode from "../enum/AssetContentMode";

const ProductList: WidgetDefinition = {

    type: WidgetType.PRODUCT_LIST,
    className: 'widget-product-list',
    contentComponent: 'dmb-widget-content-product-list',

    settingsSectionComponents: [
        'dmb-section-widget-settings-productlist-products',
        'dmb-section-widget-settings-productlist-elements',
        'dmb-section-widget-style',
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 0.6,
        height: 0.5
    },

    defaultStyle: {
        opacity: 100,
        padding: 10,
        contentMode: AssetContentMode.COVER
    },

    defaultSettings: (options) => ({
        showCategory: true,
        showTitle: true,
        showSubtitle: true,
        showVariant: true,
        showPrice: true,
        showCurrency: true,
        showImage: false,
        imageSize: null,
        showLabels: true,
        showLabelImage: true,
        showLabelBackground: true,
        showLabelText: true,
        labelImageSize: 24,
        labelPosition: ProductSubtitlePosition.NEXT,
        subtitlePosition: ProductSubtitlePosition.BELOW,
        priceMode: PriceMode.DECIMAL_COMMA,
        rowSpacing: null,
        categoryId: options.isTemplate ? '0' : null,
        categoryTextStyle: {
            size: 30,
            font: Font.PRIMARY,
            bold: true,
            color: 'FFFFFF',
            alignment: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        titleTextStyle: {
            font: Font.PRIMARY,
            size: 22,
            lineSpacing: 2,
            bold: true,
            color: 'FFFFFF',
            alignment: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        subtitleTextStyle: {
            font: Font.PRIMARY,
            size: 18,
            color: 'FFFFFF',
            alignment: null,
            bold: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        variantTextStyle: {
            font: Font.PRIMARY,
            size: 20,
            bold: true,
            color: 'FFFFFF',
            alignment: TextAlignment.LEFT,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        priceTextStyle: {
            font: Font.PRIMARY,
            size: 20,
            lineSpacing: 2,
            color: 'FFFFFF',
            alignment: null,
            bold: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        labelTextStyle: {
            font: Font.PRIMARY,
            size: 14,
            bold: true,
            color: 'FFFFFF',
            alignment: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle
    })
}

export default ProductList